import { render, staticRenderFns } from "./AppSidebar.vue?vue&type=template&id=d23ec338&scoped=true"
import script from "./AppSidebar.vue?vue&type=script&lang=js"
export * from "./AppSidebar.vue?vue&type=script&lang=js"
import style0 from "./AppSidebar.vue?vue&type=style&index=0&id=d23ec338&prod&scoped=true&lang=css"
import style1 from "./AppSidebar.vue?vue&type=style&index=1&id=d23ec338&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d23ec338",
  null
  
)

export default component.exports